"use strict";
var $dyn;
(function ($dyn) {
    var forms;
    (function (forms) {
        /**
         * Enumeration that describes the display target for a form.
         */
        var DisplayTarget;
        (function (DisplayTarget) {
            /** The default target */
            DisplayTarget[DisplayTarget["Default"] = 0] = "Default";
            /** The target is aside pane */
            DisplayTarget[DisplayTarget["AsidePane"] = 1] = "AsidePane";
            /** The form will remain hidden */
            DisplayTarget[DisplayTarget["Hidden"] = 2] = "Hidden";
        })(DisplayTarget = forms.DisplayTarget || (forms.DisplayTarget = {}));
        /**
         * Enumeration that describes the styles for forms for moving the view button
         */
        var Styles;
        (function (Styles) {
            Styles["DetailsFormMaster"] = "DetailsFormMaster";
            Styles["ListPage"] = "ListPage";
            Styles["SimpleList"] = "SimpleList";
            Styles["DetailsFormTransaction"] = "DetailsFormTransaction";
            Styles["SimpleListDetails"] = "SimpleListDetails";
            Styles["Dialog"] = "Dialog";
        })(Styles = forms.Styles || (forms.Styles = {}));
        /**
         * Enumeration that describes the location for SavedViews button
         */
        var ViewsButtonLocation;
        (function (ViewsButtonLocation) {
            ViewsButtonLocation["MainCaption"] = "MainCaption";
            ViewsButtonLocation["TopEntityName"] = "TopEntityName";
            ViewsButtonLocation["DialogCaption"] = "DialogCaption";
            ViewsButtonLocation["TopContext"] = "TopContext";
        })(ViewsButtonLocation = forms.ViewsButtonLocation || (forms.ViewsButtonLocation = {}));
        /**
         * Enumeration that describes the focus target for FactBox
         */
        var FactBoxFocusTarget;
        (function (FactBoxFocusTarget) {
            /** The target is Form */
            FactBoxFocusTarget[FactBoxFocusTarget["Form"] = 1] = "Form";
            /** The target is FactBox */
            FactBoxFocusTarget[FactBoxFocusTarget["FactBox"] = 2] = "FactBox";
        })(FactBoxFocusTarget = forms.FactBoxFocusTarget || (forms.FactBoxFocusTarget = {}));
        var Events;
        (function (Events) {
            Events["partCreated"] = "partCreated";
            Events["gridLayoutCompleted"] = "gridLayoutCompleted";
            Events["personalize"] = "PersonalizeForm";
        })(Events = forms.Events || (forms.Events = {}));
    })(forms = $dyn.forms || ($dyn.forms = {}));
})($dyn || ($dyn = {}));

//# sourceMappingURL=FormEnums.js.map
